import React, { PureComponent } from 'react';
import Overview from 'bundles/Dashboard/components/Overview';
import { Button, ButtonGroup } from '@material-ui/core'
// import { CustomTooltip } from 'shared/mui-styles';

class FunctionArea extends PureComponent {
    render() {
        const {
            filterResultsCount,
            filterResultsCountPipeline,
            totalSubUnits,
            totalRiskUnits,
            totalSubUnitsPipeline,
            mapOrTable,
            setView,
            rawResultsCount,
            rawResultsCountPipeline,
            // loggedIn,
        } = this.props;

        // const Btn = (
        //     <Button
        //         variant="contained"
        //         color="primary"
        //         disabled={!loggedIn}
        //         onClick={() => { console.log('hi') }}
        //     >
        //         Download Data
        //     </Button>
        // );

        // const BtnWithTooltip = (
        //     <CustomTooltip
        //         title="You must be registered and logged in to download data"
        //         placement="right"
        //     >
        //         <div>{Btn}</div>
        //     </CustomTooltip>
        // )

        return (
            <div className="function-area">
                <Overview
                    rawPropCount = {rawResultsCount}
                    rawPropCountPipeline = {rawResultsCountPipeline}
                    propCount={filterResultsCount}
                    propCountPipeline = {filterResultsCountPipeline}
                    subCount={totalSubUnits}
                    riskCount={totalRiskUnits}
                    totalSubUnitsPipeline = {totalSubUnitsPipeline}
                />
                {/* {!!mapOrTable && (
                    <div className="left-area">
                        {loggedIn ? (Btn) : (BtnWithTooltip)}
                    </div>
                )} */}
                <div className="right-area">
                    <ButtonGroup variant="contained" color="secondary">
                        <Button
                            className={mapOrTable === -1 ? 'selected' : ''}
                            onClick={() => setView(-1)}
                        >
                            Snapshot
                        </Button>
                        <Button
                            className={mapOrTable === 1 ? 'selected' : ''}
                            onClick={() => setView(1)}
                        >
                            Table
                        </Button>
                        <Button
                            className={mapOrTable === 0 ? 'selected' : ''}
                            onClick={() => setView(0)}
                        >
                            Map
                        </Button>
                    </ButtonGroup>
                </div>
            </div>
        )
    }
}

export default FunctionArea